export default {"src":"/_next/static/media/gas.e707681f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};